import React from 'react';
import { Link } from 'react-router-dom';
import './PathwaysBox.css';
import { getRandomImage } from '../../hooks/helpers';
import { IBLSpinLoader } from '../IBLSpinLoader';

export const PathwaysBox = ({ userPathwaysLoaded, userPathways , username}) => {
  if (!userPathwaysLoaded) {
    return <IBLSpinLoader size={40} containerHeight="150px" />;
  }

  return (
    <div className="div-block-430 sl pathway_grid">
      {
        <div
          id="w-node-f31e1962-462b-8b0d-0045-72a4bb836b6c-a52aa012"
          className="item-box path_box">
          <Link
            to="/profile/pathways/new"
            className="link-block-31 w-inline-block">
            <div className="div-block-444">
              <div className="div-block-394">
                <img
                  src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66babee_plus.png"
                  loading="lazy"
                  alt=""
                  className="image-142"
                />
              </div>
              <div className="c_p">Create Pathway</div>
            </div>
          </Link>
        </div>
      }

      {
        userPathways.map((pathway, index) => (
          <div
            key={index}
            id="w-node-_9d122df3-5436-acb4-d16f-30b76ec43f9d-27264aa9"
            className="item-box path_box">
            <Link
              to={`/profile/pathways/${pathway.pathway_uuid}/${username}`}
              className="link-block-31 w-inline-block"
            >
              <div className="div-block-411">
                <img
                  src={getRandomImage()}
                  loading="lazy"
                  sizes="(max-width: 767px) 234px, (max-width: 991px) 295.734375px, (max-width: 1279px) 21vw, 226.5px"
                  alt="pathway-image"
                  className="image-155"
                />
                <div className="label c">
                  <div className="text-block-294">PATHWAY</div>
                </div>
              </div>
              <div className="item-body">
                <div className="div-block-417">
                  <div className="div-block-461">
                    <img
                      src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66baaf9_google.png"
                      loading="lazy"
                      sizes="100vw"
                      srcSet="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66baaf9_google-p-500.png 500w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66baaf9_google.png 512w"
                      alt=""
                      className="image-167"
                    />
                  </div>
                  <div className="text-block-235">Google</div>
                  <div className="div-block-523">
                    <div className="text-block-233">120 Skill Coins</div>
                  </div>
                </div>
                <div className="text-block-225">{pathway.name}</div>


              </div>
            </Link>
          </div>
        ))}
    </div>


  );
};